<template>
  <div ref="chartWrapper"
       class="widget-wrapper"
  >
<!--       class="widget-wrapper pad0">-->
    <div ref="chartWrapperOpts"
         class="widget-contents-option"
    >
      <div style="flex-grow: 1"/>
      <q-select v-if="(opts.mach_id_options || []).length > 1"
                style="width: 100px;"
                class="bs bs-q-sm bs-q-select bs-q-select-default"
                :value="opts.mach_id"
                :options="opts.mach_id_options || []"
                :auth-force="true"
                @change="onChangeChartOptions"
      />
    </div>
    <div class="widget-contents">
      <div class="row" style="margin-top:-10px">
        <gauge-chart ref="chartInstanceMem"
                     class="col-xs-4 col-sm-4 col-md-4"
                     :data="widgetData.mem"
                     :title-font-size="getFontSize"
                     :detail-font-size="getFontSize"
                     :titleOffset="isMaximumWidget ? ['0%', '-20%'] : ['0%', '-27%']"
                     :detailOffset="isMaximumWidget ? ['0%', '15%'] : ['0%', '27%']"
                     :radius="'70%'"
                     :axisLine="{lineStyle: {width: isMaximumWidget ? 9 : 4}}"
        />
        <gauge-chart ref="chartInstanceCpu"
                     color="#8c80ec"
                     class="col-xs-4 col-sm-4 col-md-4"
                     :data="widgetData.cpu"
                     :title-font-size="getFontSize"
                     :detail-font-size="getFontSize"
                     :titleOffset="isMaximumWidget ? ['0%', '-20%'] : ['0%', '-27%']"
                     :detailOffset="isMaximumWidget ? ['0%', '15%'] : ['0%', '27%']"
                     :radius="'70%'"
                     :axisLine="{lineStyle: {width: isMaximumWidget ? 9 : 4}}"
        />
        <gauge-chart ref="chartInstanceDisk"
                     color="#24d6c7"
                     class="col-xs-4 col-sm-4 col-md-4"
                     :data="widgetData.disk"
                     :title-font-size="getFontSize"
                     :detail-font-size="getFontSize"
                     :titleOffset="isMaximumWidget ? ['0%', '-20%'] : ['0%', '-27%']"
                     :detailOffset="isMaximumWidget ? ['0%', '15%'] : ['0%', '27%']"
                     :radius="'70%'"
                     :axisLine="{lineStyle: {width: isMaximumWidget ? 9 : 4}}"
        />
      </div>
      <div class="row" style="margin-top:-10px">
        <trend-chart
          ref="chartInstanceTrend"
          :data="widgetData.trend"
          :grid="{ right: '1%'}"
          :legend="false"
          :x-axis="xAxis"
          :y-axis="yAxis"
          :series="series"
          :tooltip="tooltip"
          :zoom="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import Moment from 'moment'
  // 대시보드 유틸
  // import {top10Color} from '~/utils/charts'
  // Mixin 객체
  import {widgetMixin} from '~/mixins/widgetCommonMixin'
  // 스토어 헬퍼
  import {createNamespacedHelpers} from 'vuex'
  import {isMaximum} from '../../../../../plugins/validate/customRules/customRules'
  // 스토어 헬퍼 객체
  const {mapGetters} = createNamespacedHelpers('common/common')
  const {mapState, mapActions} = createNamespacedHelpers('dashboard/dashboard')

  export default {
    name: 'widgetSysResource',
    directives: {},
    mixins: [widgetMixin],
    data () {
      return {
        w: 2,
        self: this,
        title: 'widgetSysResource',
        isLock: false,
        isMove: true,
        isResize: true,
        isRefresh: true,
        eventBus: true,
        allUpdate: false,
        opts: {
          isDeviceFilter: false // TAMS
        },
        restData: {
          result: [],
          unit_time: ''
        },
        widgetData: {
          mem: [],
          cpu: [],
          disk: [],
          trend: []
        },
        timerValue: 60000,
        timerObject: null,
        tempTrend: [],
        series: [
          { id: 'system_mem', type: 'line', name: 'MEM', smooth: 0.6, lineStyle: {width: 1}, symbol: 'circle', showSymbol: false, triggerLineEvent: true },
          { id: 'system_cpu', type: 'line', name: 'CPU', smooth: 0.6, color: '#8c80ec', lineStyle: {width: 1}, symbol: 'circle', showSymbol: false, triggerLineEvent: true },
          { id: 'system_disk', type: 'line', name: 'DISK', smooth: 0.6, color: '#24d6c7', lineStyle: {width: 1}, symbol: 'circle', showSymbol: false, triggerLineEvent: true }
        ],
        xAxisRawData: {
          type: 'time',
          axisLine: { onZero: true },
          axisLabel: {
            formatter: '{HH}:{mm}:{ss}  ',
            hideOverlap: true
          }
        },
        yAxisRawData: {
          min: 0,
          max: 100,
          type: 'value',
          interval: 50,
          position: 'left'
        }
      }
    },
    computed: {
      ...mapState([
        'filterDate'
      ]),
      ...mapGetters([
        'getDeviceTime'
      ]),
      xAxis: {
        get () {
          return this.xAxisRawData
        },
        set (options) {
          this.xAxisRawData = options
        }
      },
      yAxis: {
        get () {
          return this.yAxisRawData
        },
        set (options) {
          this.yAxisRawData = options
        }
      },
      tooltip () {
        const tooltipOptions = {axisPointer: {type: 'line'}}

        tooltipOptions.formatter = (params) => {
          let resFormat = `<b>${params[0].axisValueLabel.split(' ')[1]}</b><br>`
          for (let i = 0, max = params.length; i < max; i++) {
            const maker = `${params[i].marker}`
            const title = `${params[i].seriesId === 'system_cpu' ? 'CPU' : params[i].seriesId === 'system_mem' ? 'MEM' : 'DISK'}`
            const value = `${params[i].value[1]}%`

            resFormat += `${maker}${title} : <b>${value}</b><br>`
          }
          return resFormat
        }
        return tooltipOptions
      },
      getFontSize () {
        const bodyFontSize = window.getComputedStyle(document.body).fontSize
        const defaultFontSize = parseFloat(bodyFontSize)
        return this.isMaximumWidget ? defaultFontSize * 2 : defaultFontSize * 0.9
      }
    },
    beforeCreate () {},
    created () {},
    beforeMount () {},
    mounted () {
      // 타이머 객체 생성
      // this.timerObject = setInterval(this.getWidgetContentsData, this.timerValue)
    },
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {
      // 셀프 객체 초기화
      this.self = null
    },
    destroyed () {},
    errorCaptured () {},
    methods: {
      isMaximum,
      ...mapActions([
        'getWidgetData'
      ]),
      async onChangeChartOptions (value) {
        this.opts.mach_id = value
        this.getWidgetContentsData(true)
      },
      getTrendData (trendData) {
        const cpuUseage = []
        const diskUseage = []
        const memoryUseage = []
        const trendResult = trendData.result.result
        const tickInterval = this.filterDate === 60 ? 1 : 10
        const minute = tickInterval * 60 * 1000
        const stime = trendResult[0].time
        const etime = trendResult[trendResult.length - 1].time

        const sTimestamp = Moment(stime).valueOf(), eTimestamp = Moment(etime).valueOf()
        let increaseTime = sTimestamp

        // stime ~ etime 시간 범위계산 (해당 장비에 대해 해당 시간 범위 내 데이터 없을 경우 0 처리)
        let idx = 0
        const doSomeThing = (incTime) => {
          if (increaseTime > eTimestamp) {
            cpuUseage.push([increaseTime, 0])
            diskUseage.push([increaseTime, 0])
            memoryUseage.push([increaseTime, 0])
            return incTime + minute
          }
          const resourceTrend = trendResult[idx]
          const trendTime = Moment(resourceTrend.time).startOf('minutes').valueOf()
          if (increaseTime > trendTime) {
            idx++
            return incTime
          }
          if (increaseTime !== trendTime) {
            cpuUseage.push([increaseTime, 0])
            diskUseage.push([increaseTime, 0])
            memoryUseage.push([increaseTime, 0])
            return incTime + minute
          }
          if (resourceTrend.mach_id === this.opts.mach_id) {
            cpuUseage.push([increaseTime, resourceTrend.cpu_usage])
            diskUseage.push([increaseTime, resourceTrend.disk_usage])
            memoryUseage.push([increaseTime, resourceTrend.memory_usage])
            idx++
            return incTime + minute
          }
          idx++
          return incTime
        }
        while (increaseTime <= eTimestamp) {
          increaseTime = doSomeThing(increaseTime)
        }
        return [memoryUseage, cpuUseage, diskUseage]
      },
      initWidget () {
        this.widgetData = { mem: [], cpu: [], disk: [], trend: [] }
        // 차트 씨리즈 초기화
        this.$refs.chartInstanceMem.clear()
        this.$refs.chartInstanceCpu.clear()
        this.$refs.chartInstanceDisk.clear()
        this.$refs.chartInstanceTrend.clear()
      },
      async getWidgetContentsData (init = false) {
        this.showProgress(true) // Progress 출력 여부
        if (init) this.initWidget() // initFlag가 True면 기존 차트 데이터 초기

        const contentsOptions = { widgetType: 'system_resource_trend' }
        const currentResourceOptions = { widgetType: 'system_resource_status' }
        /*
          10초 데이터 초기화 시 (실시간 추이 데이터)
          현재 장비시간의 -30초 ~ 10초 이전 데이터 호출
          실시간 위젯은 위젯 데이터를 30초를 뺀 시간을 기준으로 한다. (Ex. 14:05:37초일 경우 기본 계산 시간은 14:05:07초)
        */
        const calcBaseTime2 = Moment(this.getDeviceTime).subtract(1, 'minutes')
        const endTime2 = calcBaseTime2.seconds(0) // 계산된 시간에서 1초 단위를 초기화. (14:05:00)
        const startTime2 = _.cloneDeep(endTime2).subtract(1, 'minutes') // 계산된 endTime에서 10초 빼기. (14:04:50)
        currentResourceOptions.eTime = endTime2.subtract(1, 'seconds').format('YYYY-MM-DD HH:mm:ss') // endTime에서 1초 빼기 (14:04:59)
        currentResourceOptions.sTime = startTime2.format('YYYY-MM-DD HH:mm:ss') // startTime 추가 (13:05:00 ~ 14:04:59로 최초 요청)
        /* TAMS 장비 아이디 추출 (ui-data 이용) */
        const machIds = [], filterMachIds = []
        const tamsInfo = this.$store.state.common.common.uiData.system.tams_info
        for (const mmbr of tamsInfo) {
          machIds.push({ label: mmbr.device_uname, value: mmbr.device_id })
          filterMachIds.push(mmbr.device_uname)
        }
        contentsOptions.filterDeviceList = filterMachIds
        currentResourceOptions.filterDeviceList = filterMachIds
        // API 호출
        const trendData = await this.getWidgetData(contentsOptions) // 실시간 리소스 추이 데이터
        const currentData = await this.getWidgetData(currentResourceOptions)

        this.opts.mach_id_options = machIds
        if (typeof this.opts.mach_id === 'undefined') {
          this.opts.mach_id = this.opts.mach_id_options[0].value
        } else {
          this.opts.mach_id = parseInt(this.opts.mach_id)
          if (!this.opts.mach_id_options.some(item => this.opts.mach_id === item.value)) {
            this.opts.mach_id = this.opts.mach_id_options[0].value
          }
        }

        // Series 데이터 구성
        if (trendData.code === 'ok' && _.get(trendData, ['result', 'result', 'length'], 0) > 0) {
          this.widgetData.trend = this.getTrendData(trendData)
        } else {
          // TAMS - All update 기준
          this.widgetData.trend = [] // 데이터 초기화
          this.$refs.chartInstanceTrend.clear() // 차트 씨리즈 초기화
        }
        if (currentData.code === 'ok' && _.size(currentData.result.result) > 0) {
          // Guage 차트 설정
          let currentResourceData = currentData.result.result.find(row => row.mach_id === this.opts.mach_id)
          if (typeof currentResourceData === 'undefined') currentResourceData = { memory_usage: 0, cpu_usage: 0, disk_usage: 0 }
          this.widgetData.mem = [ { name: 'MEM', value: currentResourceData.memory_usage } ]
          this.widgetData.cpu = [ { name: 'CPU', value: currentResourceData.cpu_usage } ]
          this.widgetData.disk = [ { name: 'DISK', value: currentResourceData.disk_usage } ]
        } else {
          // TAMS - All update 기준, 데이터 초기화
          this.widgetData.mem = []
          this.widgetData.cpu = []
          this.widgetData.disk = []
          // 차트 씨리즈 초기화
          this.$refs.chartInstanceMem.clear()
          this.$refs.chartInstanceCpu.clear()
          this.$refs.chartInstanceDisk.clear()
        }
        this.showProgress(false) // Progress 출력 여부
      },
      onResizeContentsFromWidget () {
        // 차트 래퍼 컨테이너 객체
        const chartWrapper = this.$refs.chartWrapper

        // 차트 래퍼가 있으면 다음단계 진행
        if (chartWrapper) {
          // 래퍼 크기 구하기
          const wrapperWidth = chartWrapper.clientWidth
          let wrapperHeight = chartWrapper.clientHeight < 219 ? 219 : chartWrapper.clientHeight || 219

          // Max 팝업인 경우 부모 기준 여백 위아래 30 * 2 - 헤더 부분 97
          if (this.isMaximumWidget) {
            wrapperHeight = this.parent.$el.clientHeight - 60 - 97
          } else {
            wrapperHeight -= 20
          }

          // 인스턴스 사이즈 조절
          const gaugeWidth = wrapperWidth / 3
          const gaugeHeight = wrapperHeight / 2
          const trendHeight = wrapperHeight / 2

          this.$refs.chartInstanceMem.setSize(gaugeWidth, gaugeHeight)
          this.$refs.chartInstanceCpu.setSize(gaugeWidth, gaugeHeight)
          this.$refs.chartInstanceDisk.setSize(gaugeWidth, gaugeHeight)
          this.$refs.chartInstanceTrend.setSize(wrapperWidth - 20, trendHeight)
        }
      },
      addMachId (trend, ids) {
        const matchIds = _.map(ids, item => { return item.value })
        for (const row of trend) {
          const machId = row.mach_id
          if (!matchIds.includes(machId)) {
            ids.push({
              label: row.mach_name.toString(),
              value: row.mach_id
            })
          }
        }
        return ids
      }
    },
    watch: {}
  }
</script>

<style scoped>
  .widget-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .widget-contents-option {
    right: 0;
    display: flex;
    padding-top: 5px;
    padding-right: 5px;
    margin-bottom: 5px;
  }

  .widget-contents {
    /*flex: 1;*/
    display: flex;
    /*flex-direction: column;*/
  }

  .widget-contents-option select {
    width: 100px;
    height: 25px;
    font-size: 10pt;
  }
  /*.widget-contents-wrapper {*/
  /*  flex-grow: 1;*/
  /*  display: flex;*/
  /*  position: relative;*/
  /*}*/

  /*.widget-contents-option {*/
  /*  z-index: 10;*/
  /*  right: 0;*/
  /*  display: flex;*/
  /*  position: absolute;*/
  /*  padding-top: 5px;*/
  /*  padding-right: 17px;*/
  /*  margin-bottom: 5px;*/
  /*}*/

  /*.widget-contents-chart {*/
  /*  flex-grow: 1 !important;*/
  /*}*/
</style>
